import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  AdminProfile,
  CompOffSpecificLeave,
  UpdateAdminCompOffLeaveStatus,
} from "../../Repository/Api";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import CustomModal from "../CustomModal";
import { errorMsg, successMsg } from "../Toastify";

const AdminSpecificComprequestview = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const { id } = useParams();
  const navigate = useNavigate();

  const [SpecificProfile, setSecificProfile] = useState({});
  const [statusAcceptModel, setStatusAcceptModel] = useState(false);
  const [createStatus, setCreateStatus] = useState([]);
  const [validation, setValidation] = useState({});

  useEffect(() => {
    getSpecificlist();
  },[]);

  const getSpecificlist = async () => {
    const response = await CompOffSpecificLeave(id, token);
    if (response && response.statusCode === 200) {
      setSecificProfile(response.data);
    } else {
      errorMsg(response.message);
    }
  };
  const setData = (e, key) => {
    let TempData = createStatus;
    TempData[key] = e;
    setCreateStatus(TempData);
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };
  const CheckValidation = () => {
    let Status = true,
      validdateData = {};
    if (!createStatus.admin_comment) {
      validdateData.admin_comment = "Comment is Required";
      Status = false;
    }
    setValidation({ ...validation, ...validdateData });
    return Status;
  };
  const handleApproveSubmit = async (e) => {
    e.preventDefault();
    const Payload = {
      id: id,
      admin_status: "forwarded",
      admin_comment: createStatus.admin_comment,
    };
    if (CheckValidation()) {
      const response = await UpdateAdminCompOffLeaveStatus(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateStatus({});
        e.target.reset();
        setStatusAcceptModel(false);
        window.location.reload();
      } else {
        errorMsg(response.message);
      }
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle">
                  <span
                    className="arrowicon"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    ← &nbsp;
                  </span>
                  Comp Off Leave Request List
                </h6>
                <div className="row">
                  <div className="col-lg-3">
                    <label className="labeltext">Name of the Applicant</label>
                    <input
                      type="text"
                      className="fieldinput"
                      value={SpecificProfile?.first_name}
                      disabled
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext">Designation</label>
                    <input
                      type="text"
                      className="fieldinput"
                      value={SpecificProfile?.designation}
                      disabled
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext">Worked Date</label>
                    <input
                      type="text"
                      className="fieldinput"
                      value={moment(SpecificProfile?.date).format("DD-MM-yyyy")}
                      disabled
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext">Expiry Date</label>
                    <input
                      type="text"
                      className="fieldinput"
                      value={moment(SpecificProfile?.expiry_date).format(
                        "DD-MM-yyyy"
                      )}
                      disabled
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext">Description</label>
                    <textarea
                      type="text"
                      className="fieldinput"
                      value={SpecificProfile?.description}
                      disabled
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext">Hod Comment</label>
                    <textarea
                      type="text"
                      className="fieldinput"
                      value={SpecificProfile?.hod_comment}
                      disabled
                    />
                  </div>
                  {SpecificProfile?.admin_comment ? (
                    <div className="col-lg-3">
                      <label className="labeltext">Admin Comment</label>
                      <textarea
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.admin_comment}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {!SpecificProfile?.admin_comment ? (
                  <div className="row my-5">
                    <div className="col-lg-3 mx-auto my-auto centertext">
                      <button
                        className="approvebutton"
                        onClick={() => {
                          setStatusAcceptModel(true);
                        }}
                      >
                        Forword
                      </button>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </section>

        {/*  ApproveModal */}
        <CustomModal
          open={statusAcceptModel}
          onClickOutside={() => {
            setStatusAcceptModel(false);
            setCreateStatus({});
            setValidation({});
          }}
        >
          <form onSubmit={(e) => handleApproveSubmit(e)}>
            <div className="modal-content Modal-View m-auto">
              <div className="modalHeader text-center py-2">
                <h5 className="font-bold mt-2">Admin Status</h5>
              </div>
              <div className="modal-body p-0 ">
                <div className="container">
                  <div className="row d-flex align-items-center justify-content-center  mt-0">
                    <div className="container ">
                      <div className="row justify-content-center">
                        <div className="col-lg-8">
                          <div className=" my-5 px-3">
                            <div className="row justify-content-center mt-2">
                              <div className="col-lg-10">
                                <div className="mb-3">
                                  <label className="labeltext">
                                    Admin Comment
                                  </label>
                                  <textarea
                                    type="text"
                                    className="fieldinput"
                                    placeholder="Enter Comment"
                                    defaultValue={createStatus.admin_comment}
                                    onChange={(e) => {
                                      setData(e.target.value, "admin_comment");
                                    }}
                                  />
                                  {validation.admin_comment && (
                                    <p className="validationerror">
                                      {validation.admin_comment}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <div className="my-3">
                  <button
                    type="button"
                    className="btn mx-2 modelclosebtn"
                    onClick={() => {
                      setStatusAcceptModel(false);
                      setValidation({});
                      setCreateStatus({});
                    }}
                  >
                    Back
                  </button>
                </div>
                <div>
                  <button className="btn mx-2 modelsubmitbtn">Forward</button>
                </div>
              </div>
            </div>
          </form>
        </CustomModal>
      </div>
    </>
  );
};

export default AdminSpecificComprequestview;
